import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { getAuthToken } from '../auth';

import AwsExports from './AwsExports';

const httpLink = createHttpLink({
  uri: AwsExports.graphqlEndpoint
});

const authLink = setContext(async (_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: await getAuthToken()
    }
  };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

export default apolloClient;



// WEBPACK FOOTER //
// ./src/api/apolloClient.js